/**
 * One canonical address keeps visitors, cookies and search engines on a single origin.
 * The host is CMS-editable (`settings.canonical_url`), and only the www/apex twin of that
 * host is ever redirected — preview and staging origins are left alone.
 */
export function canonicalOrigin(settings) {
  const raw = (settings?.canonical_url || "").trim().replace(/\/+$/, "");
  if (!/^https?:\/\//.test(raw)) return "";
  return raw;
}

const bareHost = (host) => host.replace(/^www\./, "").toLowerCase();

export function redirectTarget(settings, location = window.location) {
  const canonical = canonicalOrigin(settings);
  if (!canonical) return null;
  let target;
  try {
    target = new URL(canonical);
  } catch {
    return null;
  }
  const here = location.hostname.toLowerCase();
  if (here === target.hostname.toLowerCase()) return null;
  // only the other spelling of the same domain moves; never a preview host
  if (bareHost(here) !== bareHost(target.hostname)) return null;
  return `${target.origin}${location.pathname}${location.search}${location.hash}`;
}

export function enforceCanonicalHost(settings) {
  const target = redirectTarget(settings);
  if (target) window.location.replace(target);
}
